module.exports = __webpack_public_path__ + "img/logo-loading.c3c7def8.gif";